export const environment = {
    production: true,
    gapi: {
        client: '210014939830-e4cq3jhq1cdra0g0uupl0k64kp7t77ab.apps.googleusercontent.com',
        apiKey: 'AIzaSyAzY_ztXX80qkCgTeK4vo26GPXqJcsCqns'
    },
    firebase: {
        apiKey: "AIzaSyCv9nGX-g9Ecwo6o8R8a3ZqXFqpC9Ox79w",
        authDomain: "linescale-dev.firebaseapp.com",
        databaseURL: "https://linescale-dev.firebaseio.com",
        projectId: "linescale-dev",
        storageBucket: "linescale-dev.appspot.com",
        messagingSenderId: "210014939830",
        appId: "1:210014939830:web:d28fa9b724937004491417"
    },
    // apiUrl: 'https://api.h2delta.com',
    apiUrl: '',
    authURL: '/auth',
    useEmulators: false,
  clientPortalUrl: 'https://portal.linescale.dev',
  advancedToolsUrl: 'https://apps.linescale.dev',
  resetId: '2025-06-1'
};
